module.exports = [
  {
    id: 1,
    title: "CONTACT US",
    colClass: "col-lg-3",
    menuList: [
      { name: "T: 011 454 0191", route: "#" },
      { name: "T: 011 454 0212", route: "#" },
      { name: " E: recruit@myorigins.co.za", route: "#" },
      
    ],
  },
  {
    id: 2,
    title: "FOOTER LINKS",
    menuList: [
      { name: "Privacy Policy", route: "/privacy-policy" },
      { name: "Terms & Conditions", route: "/terms-conditions" },
      { name: "PAIA Manual", route: "https://myorigins.co.za/wp-content/uploads/2020/11/Origins-PAIA-Manual.pdf" },

  



    ],
  },
  {
    id: 3,
    

    title: "OPERATING HOURS",
    menuList: [
      { name: "Monday-Friday 07:30-15:30", route: "" },    
      // { name: "Terms Page", route: "/terms" },
      // { name: "Blog", route: "/blog-list-v1" },
      // { name: "Contact", route: "/contact" },
    ],
  },
  {
    id: 4,
    title: "",
    menuList: [
      {
        name: "",
        route: "#",
        content: (
          <div className='footer-column about-widget'>
            <div className='logo'>
              <a href='#'>
                <img src='/APSO-logo.png' alt='brand' width={100} height={50} />
              </a>
            </div>
          </div>
        ),
      },
    ],
  },
];
